import React from 'react';
import { ISVGType } from './SVGType';

const HidePasswordEyeSVG: React.FC<ISVGType> = (props) => {
  const { height = 21, width = 24, color = "#4A3FC5" } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 21"
      fill="none"
    >
      <path
        d="M13.3946 3.67072C12.9367 3.6212 12.4715 3.59282 12 3.58576C9.93951 3.5949 7.80355 4.0961 5.78174 5.05648C4.28058 5.79892 2.81828 6.84707 1.54834 8.13997C0.924641 8.79997 0.12862 9.75561 0 10.7752C0.0152 11.6585 0.963061 12.7486 1.54834 13.4105C2.7392 14.6526 4.16342 15.6708 5.78174 16.494C5.83674 16.5207 5.89194 16.5471 5.94727 16.5731L4.44582 19.1951L6.48593 20.4008L17.5143 1.20016L15.5505 0L13.3946 3.67072ZM18.0513 4.9803L16.5527 7.57745C17.2421 8.47309 17.6514 9.57757 17.6514 10.7752C17.6514 13.7604 15.1209 16.1805 11.9985 16.1805C11.8636 16.1805 11.7327 16.1659 11.6001 16.1571L10.6084 17.8739C11.0657 17.9228 11.5282 17.9585 12 17.9647C14.0625 17.9554 16.1972 17.4484 18.2168 16.494C19.718 15.7515 21.1817 14.7034 22.4517 13.4105C23.0754 12.7505 23.8714 11.7948 24 10.7752C23.9848 9.89199 23.0369 8.80183 22.4517 8.13995C21.2608 6.89783 19.8351 5.87968 18.2168 5.05644C18.1622 5.02996 18.1063 5.00614 18.0513 4.9803ZM11.9985 5.36996C12.1355 5.36996 12.2713 5.37544 12.4058 5.3846L11.2441 7.39583C9.61387 7.72635 8.39063 9.11343 8.39063 10.7738C8.39063 11.1909 8.46745 11.5901 8.60889 11.9603C8.60905 11.9607 8.60873 11.9613 8.60889 11.9618L7.44433 13.9788C6.75331 13.0824 6.34569 11.9743 6.34569 10.7752C6.34571 7.79009 8.87617 5.36994 11.9985 5.36996ZM15.3779 9.61067L12.7603 14.1458C14.3818 13.8091 15.5962 12.4283 15.5962 10.7738C15.5962 10.3643 15.5145 9.97499 15.3779 9.61067Z"
        fill={color}
      />
    </svg>
  );
};

export default HidePasswordEyeSVG;
